import { Component, OnInit, Input, Output, forwardRef, EventEmitter } from '@angular/core';
import { FormBuilder, UntypedFormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, ControlValueAccessor, Validators } from '@angular/forms';



@Component({
  selector: 'app-national-insurance-number',
  templateUrl: './national-insurance-number.component.html',
  styleUrls: ['./national-insurance-number.component.scss'],
  providers: [
    {
      provide: NG_VALIDATORS, useExisting: NationalInsuranceNumberComponent, multi: true
    },
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NationalInsuranceNumberComponent),
      multi: true
    }]
})
export class NationalInsuranceNumberComponent implements OnInit {
  onTouched: () => void;
  onChange = (value: string) => { }; 

  @Input() controllerData;
  @Input() parent: UntypedFormGroup;
  @Input() pageName:string;
  @Input() controlName:string;
  

  @Output() textChangeEventEmitter: EventEmitter<string> = new EventEmitter<string>();

  constructor() {
  }

  ngOnInit() {
  }
  writeValue(value: any): void {
    this.controllerData['value'] = value ? value: null;
  }
  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  inputTextChangeHandler(val){
    this.textChangeEventEmitter.emit(val);
  }

  validate() {
    const nameValidation: RegExp = /^(?!BG|GB|NK|KN|TN|NT|ZZ)[A-CEGHJ-PR-TW-Z][A-CEGHJ-NPR-TW-Z](?:\s*\d{2}){3}\s*[A-D]$/;
    const forbidden = nameValidation.test(this.parent.get(this.controlName).value);
   

    if (this.parent.get(this.controlName).value) {
      return forbidden ? null : { invalidFormat: true};
      } return null;
  }

  onChangeHandler(tempValue) {
    let valueArray = tempValue.split('');
    if(valueArray.length > 0) {
      valueArray = valueArray.map(val => val.match(/^[A-Za-z]+$/) ? val.toUpperCase() : val);
      this.controllerData.value = valueArray.join('');
    }
  }

}
